import React from 'react'
import { Link, useLocation } from "react-router-dom";


const MobileMenu = ({handleClick}) => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  return (
    <div  className={`mobile-menu block lg:hidden  absolute top-[87px] left-0  bg-black py-6  w-full transition ease-in duration-300 ` }>
      <div className="Links flex flex-col text-center text-[20px] space-y-2 font-bold ">
            <Link
          onClick={handleClick}
              to="/about"
              className={`${
                splitLocation[1] === "about" ? "bg-primary text-white" : ""
              }  text-white transition ease-in py-2 px-4`}
            >
              <h6>ABOUT</h6>
            </Link>

            <Link
              onClick={handleClick}
              to="/showcase"
              className={`${
                splitLocation[1] === "showcase" ? "bg-primary text-white" : ""
              } text-white transition ease-in  py-2 px-4`}
            >
              <h6>SHOWCASE</h6>
            </Link>

            {/* <Link
              onClick={handleClick}
              to="/contact"
              className={`${
                splitLocation[1] === "contact" ? "bg-primary text-white" : ""
              } text-white transition ease-in py-2 px-4`}
            >
              <h6>CONTACT</h6>
            </Link> */}

         
          </div>
      </div>
  )
}

export default MobileMenu